import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useEffect } from 'react';

/**
 * 옵션에서 주문 개수 +, - 처리 
 */
const CountInputBtnBlock = styled.div`
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    font-family: Montserrat,sans-serif;
    float: ${props => props.float || 'left'};
    padding: 1px;
    
    &::after {
        content: '';
        display: block;
        clear: both;
    }
`;

const CountInputPlusMinusBlock = styled.button`
    width: ${props => props.width || '40px'};
    height: ${props => props.height || '40px'};
    background-color: #fff;
    background-size: ${props => props.isMinus ? '11px 1px' : '11px 11px'} ;
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    float: left;
`;

const CountInputBoxBlock = styled.input`
    width: ${props => props.width || '40px'};
    height: ${props => props.height || '40px'};
    border: none;
    text-align: center;
    float: left;

    &::-webkit-inner-spin-button{
        -webkit-appearance: none; 
        margin: 0; 
    }
    &::-webkit-outer-spin-button{
        -webkit-appearance: none; 
        margin: 0; 
    } 
`;

const CountInputBtn = ({ float, changeValueHandler, num, width, height, item, isDisable = false }) => {

    const [optCnt, setOptCnt] = useState(num * 1); // 옵션 Count 
    const [initCnt, setInitCnt] = useState(num * 1); // 최초 num에 의해 설정된 Count

    // console.log("item : " + JSON.stringify(item))

    useEffect(() => {
        if (num !== initCnt) {
            setInitCnt(num);
            setOptCnt(num);
        }
    }, [changeValueHandler, optCnt, num]);

    const handleClickMinusBtn = () => {
        if (optCnt > 1) {
            setOptCnt((optCnt * 1) - 1);

            if (item !== null && item !== undefined) {
                changeValueHandler(item.prdct_id, item.opt_id, (optCnt * 1) - 1);
            } else {
                changeValueHandler((optCnt * 1) - 1);
            }

        }
    }

    const handleClickPlusBtn = () => {
        if (optCnt < 100) {
            setOptCnt((optCnt * 1) + 1);
            if (item !== null && item !== undefined) {
                changeValueHandler(item.prdct_id, item.opt_id, (optCnt * 1) + 1);
            } else {
                changeValueHandler((optCnt * 1) + 1);
            }
        }

    }

    const handleInputChange = (e) => {
        // console.log("1-------------------->" + e.target.value);
        /* if (e.target.value !== '' && (e.target.value * 1 > 99 || e.target.value * 1 === 0)) {
            return;
        }

        // console.log("2-------------------->" + e.target.value);

        if (e.target.value !== '') {
            // console.log("3-------------------->" + e.target.value);
            changeValueHandler(e.target.value);
            setOptCnt(e.target.value);
        } */

        // [START] #2545 수정 - 문자 입력 방지 , 음수 방지, +- 기호 방지 
        if (isNaN(e.target.value * 1) || e.target.value * 1 < 0) {
            return;
        }

        if (e.target.value !== '' && e.target.value[0] === '+') {
            return;
        }
        // [END] #2545 수정 - 문자 입력 방지 , 음수 방지, +- 기호 방지 

        //#2769 수정
        if (e.target.value * 1 > 99) {
            return;
        }

        changeValueHandler(e.target.value);
        setOptCnt(e.target.value);

    }

    const handleFocus = (e) => {
        //#2769 수정
        if (optCnt === '' || optCnt * 1 === 0) {
            setOptCnt(1);
            changeValueHandler(1);
        }
    }

    if(isDisable === true){
        return(
        <CountInputBtnBlock float={float} style={{cursor: "auto", backgroundColor:"#f4f4f4"}}>
            <CountInputPlusMinusBlock
                isMinus={true}
                disabled={isDisable}
                width={width} height={height} 
                style={{cursor: "auto", backgroundColor:"#f4f4f4"}}/>
            <CountInputBoxBlock
                value={optCnt}
                disabled={isDisable}
                width={width} height={height}
                style={{cursor: "auto", backgroundColor:"#f4f4f4", color:"#bbbbbb"}} />
            <CountInputPlusMinusBlock
                isMinus={false}
                disabled={isDisable}
                width={width} height={height}
                style={{cursor: "auto", backgroundColor:"#f4f4f4"}} />
        </CountInputBtnBlock>
        )
    }
    return (
        <CountInputBtnBlock float={float}>
            <CountInputPlusMinusBlock
                isMinus={true}
                img="/assets/images/icon/num_minus-icon.png"
                onClick={handleClickMinusBtn}
                width={width} height={height} />
            <CountInputBoxBlock
                value={optCnt}
                onChange={handleInputChange}
                onBlur={handleFocus}
                width={width} height={height} />
            <CountInputPlusMinusBlock
                isMinus={false}
                img="/assets/images/icon/num_plus-icon.png"
                onClick={handleClickPlusBtn}
                width={width} height={height} />
        </CountInputBtnBlock>
    );
};

export default CountInputBtn;